export const EMO_FORMAT = [
    { label: '様式1', value: 'format1' },
];

export const MEASURE = (zoom: number) => [
    { label: '任意の縮尺', value: zoom, isShow: false },
    { label: '1/2500', value: 18, isShow: false },
    { label: '1/5000', value: 16, isShow: false },
    { label: '1/10000', value: 14, isShow: false },
    { label: '1/15000', value: 13, isShow: false },
    { label: '1/25000', value: 12, isShow: false },
    { label: '1/50000', value: 10, isShow: false },
];

export const DISPLAY_SETTING = [
    { label: '利用上の注意QRコードを表示', value: 'displayAttentionQRCodeOnUse', defaultChecked: true },
    { label: '凡例を表示', value: 'displayAttributeInformation', defaultChecked: false },
    { label: '定型文を表示', value: 'displayTemplate', defaultChecked: true },
];
